import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Seo from "../components/Seo";
import { SectionHead, PartnerCard, EmptyState, Loader } from "../components/Blocks";

export default function Partners() {
  const [items, setItems] = useState(null);
  const [city, setCity] = useState("all");

  useEffect(() => {
    api.get("/public/partners").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (items === null) return <Loader />;
  const cities = ["all", ...Array.from(new Set(items.map((p) => p.city).filter(Boolean)))];
  const filtered = city === "all" ? items : items.filter((p) => p.city === city);

  return (
    <div data-testid="partners-page" className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
      <Seo
        title="Partenaires"
        description="Découvrez l'atmosphère des lieux partenaires Vytali : restaurants, bars et espaces où la communauté se rencontre."
        path="/partenaires"
        kind="partner"
      />
      <SectionHead as="h1" label="Lieux" title="Partenaires">
        Pas un annuaire. Une découverte visuelle : ce que ça fait d'être là.
      </SectionHead>

      <div className="flex flex-wrap gap-3 mb-10" data-testid="partners-filters">
        {cities.map((c) => (
          <button key={c} className="vb-chip" data-active={city === c} data-testid={`partners-filter-${c}`} onClick={() => setCity(c)}>
            {c === "all" ? "Toutes les villes" : c}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <EmptyState message="Aucun partenaire publié." testid="partners-empty" />
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10" data-testid="partners-grid">
          {filtered.map((p, i) => (
            <PartnerCard key={p.id} partner={p} testid={`partner-card-${i}`} />
          ))}
        </div>
      )}
    </div>
  );
}
